<template>
	<div class="page">
		<navbar />
		<breadcrumb :list="breadcrumbList" />
		<div class="content flex-direction-column" v-if="maintenance">
			<div class="mess flex-space-between">
				<div class="swiper">
					<el-carousel ref="carousel" trigger="click" height="300px" :interval="5000" @change="(index) => (activeIndex = index)">
						<el-carousel-item v-for="(item, index) in getCarousel()" :key="index">
							<img style="width: 100%; height: 100%; object-fit: contain" :src="item" alt="" />
						</el-carousel-item>
					</el-carousel>
					<div class="indicator">
						<div class="indicator-item" :class="{ 'indicator-active': index === activeIndex }" v-for="(item, index) in getCarousel()" :key="index" @click="handleIndicatorClick(index)">
							<img :src="item" alt="" />
						</div>
					</div>
				</div>
				<div class="info flex-direction-column">
					<div class="title">
						{{ maintenance[0].standardname }}
						&nbsp;
						<span style="font-size: 20px; font-weight: normal">OEM：{{ maintenance[0].oes.join(",") }}</span>
					</div>
					<div class="table flex-wrap" v-for="item in maintenance" :key="item.goods_bianhao">
						<div class="table-item flex">
							<div class="table-item-name">SerialNumber</div>
							<div class="table-item-value">{{ item.goods_bianhao }}</div>
						</div>
						<div class="table-item flex">
							<div class="table-item-name">Remark</div>
							<div class="table-item-value">{{ item.remark || "-" }}</div>
						</div>
					</div>
				</div>
			</div>
			<span style="margin-top: 15px">Result： {{ tableData.length }}</span>
			<div class="table" style="margin-top: 20px">
				<el-table ref="multipleTable" tooltip-effect="dark" :data="tableData" :header-cell-style="{ background: '#F7F7F7', color: '#000000' }" style="width: 100%">
					<el-table-column align="center" prop="brand" label="BRAND" key="brand">
						<template #header>
							<div class="custom-header">
								BRAND
								<el-popover placement="bottom" trigger="manual" v-model="popover.brand">
									<div class="virtual-list">
										<el-checkbox-group v-model="selectedFilters.brand" class="vertical-checkbox-group">
											<el-checkbox v-for="item in filtersData.brand" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !selectedFilters.brand.length ? '#606266' : '' }" @click="confirmFilters('brand')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('brand')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('brand')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="models" label="Model" key="models">
						<template #header>
							<div class="custom-header">
								Model
								<el-popover placement="bottom" trigger="manual" v-model="popover.models">
									<div class="virtual-list">
										<el-checkbox-group v-model="selectedFilters.models" class="vertical-checkbox-group">
											<el-checkbox v-for="item in filtersData.models" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !selectedFilters.chassiscode.length ? '#606266' : '' }" @click="confirmFilters('models')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('models')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('models')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="chassiscode" label="Chassis_Code" key="chassiscode" width="220">
						<template #header>
							<div class="custom-header">
								Chassis_Code
								<el-popover placement="bottom" trigger="manual" v-model="popover.chassiscode">
									<div class="virtual-list">
										<el-checkbox-group v-model="selectedFilters.chassiscode" class="vertical-checkbox-group">
											<el-checkbox v-for="item in filtersData.chassiscode" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !selectedFilters.chassiscode.length ? '#606266' : '' }" @click="confirmFilters('chassiscode')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('chassiscode')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('chassiscode')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="sop" label="Start_time" key="sop">
						<template #header>
							<div class="custom-header">
								Start_time
								<el-popover placement="bottom" trigger="manual" v-model="popover.sop">
									<div class="virtual-list">
										<el-checkbox-group v-model="selectedFilters.sop" class="vertical-checkbox-group">
											<el-checkbox v-for="item in filtersData.sop" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !selectedFilters.sop.length ? '#606266' : '' }" @click="confirmFilters('sop')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('sop')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('sop')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="eop" label="End_time" key="eop">
						<template #header>
							<div class="custom-header">
								End_time
								<el-popover placement="bottom" trigger="manual" v-model="popover.eop">
									<div class="virtual-list">
										<el-checkbox-group v-model="selectedFilters.eop" class="vertical-checkbox-group">
											<el-checkbox v-for="item in filtersData.eop" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !selectedFilters.eop.length ? '#606266' : '' }" @click="confirmFilters('eop')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('eop')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('eop')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="enginemodel" label="Engine" key="enginemodel">
						<template #header>
							<div class="custom-header">
								Engine
								<el-popover placement="bottom" trigger="manual" v-model="popover.enginemodel">
									<div class="virtual-list">
										<el-checkbox-group v-model="selectedFilters.enginemodel" class="vertical-checkbox-group">
											<el-checkbox v-for="item in filtersData.enginemodel" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !selectedFilters.enginemodel.length ? '#606266' : '' }" @click="confirmFilters('enginemodel')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('enginemodel')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('enginemodel')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="transmissiontype" label="Transmission" key="transmissiontype">
						<template #header>
							<div class="custom-header">
								Transmission
								<el-popover placement="bottom" trigger="manual" v-model="popover.transmissiontype">
									<div class="virtual-list">
										<el-checkbox-group v-model="selectedFilters.transmissiontype" class="vertical-checkbox-group">
											<el-checkbox v-for="item in filtersData.transmissiontype" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !selectedFilters.transmissiontype.length ? '#606266' : '' }" @click="confirmFilters('transmissiontype')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('transmissiontype')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('transmissiontype')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
import { getMaintenance, getOeCar } from "@/service/api/index.js";
import navbar from "@/components/navbar/index.vue";
import breadcrumb from "@/components/breadcrumb/index.vue";
import VirtualList from "vue-virtual-scroll-list";

export default {
	components: { navbar, breadcrumb, VirtualList },
	data() {
		return {
			activeIndex: 0,
			breadcrumbList: [],
			maintenance: null,
			tableData: [],
			_tableData: [],
			filtersData: {
				brand: [],
				models: [],
				chassiscode: [],
				sop: [],
				eop: [],
				enginemodel: [],
				transmissiontype: [],
			},
			popover: {
				brand: false,
				chassiscode: false,
				models: false,
				sop: false,
				eop: false,
				enginemodel: false,
				transmissiontype: false,
			},
			selectedFilters: {
				brand: [],
				chassiscode: [],
				models: [],
				sop: [],
				eop: [],
				enginemodel: [],
				transmissiontype: [],
			},
			// 临时存储过滤器数据
			tempFiltersData: {},
		};
	},

	mounted() {
		this.getMaintenance();

		this.breadcrumbList = [...JSON.parse(this.$route.query.breadcrumbList), { name: "Maintenance", path: "" }];
	},

	methods: {
		getCarousel() {
			let _goods_imgs = [];
			for (let index = 0; index < this.maintenance.length; index++) {
				const { goods_imgs } = this.maintenance[index];

				if (goods_imgs && goods_imgs.length) return (_goods_imgs = goods_imgs);
			}

			return _goods_imgs;
		},
		handleIndicatorClick(index) {
			this.activeIndex = index;
			this.$refs.carousel.setActiveItem(index);
		},
		showPopover(key) {
			Object.keys(this.popover).forEach((item) => {
				if (item !== key) {
					this.popover[item] = false;
				}
			});
			this.popover[key] = !this.popover[key];
		},
		confirmFilters(key) {
			// 每次筛选时基于 allData 进行过滤
			let filteredData = [...this._tableData]; // 复制一份原始数据

			Object.keys(this.selectedFilters).forEach((filterKey) => {
				const selectedValues = this.selectedFilters[filterKey];
				if (selectedValues && selectedValues.length) {
					filteredData = filteredData.filter((item) => selectedValues.includes(item[filterKey]));
				}
			});

			// 更新 tableData 为筛选后的数据
			this.tableData = filteredData;

			// 关闭 popover
			this.popover[key] = false;

			// console.log("confirmFilters", this.tableData);
		},
		resetFilters(key) {
			this.showPopover(key);
			// 清空当前筛选项
			this.selectedFilters[key] = [];

			// 使用 _tableData 作为数据的起点
			let tempData = [...this._tableData];

			// 遍历其他筛选条件，应用筛选
			Object.keys(this.selectedFilters).forEach((filterKey) => {
				const selectedValues = this.selectedFilters[filterKey];
				if (selectedValues && selectedValues.length) {
					tempData = tempData.filter((item) => selectedValues.includes(item[filterKey]));
				}
			});

			// 最后更新 tableData
			this.tableData = tempData;

			console.log("resetFilters", this.tableData);
		},

		addUniqueFilter(key, value) {
			if (!value) return;

			// 如果当前 key 没有初始化，先初始化为 Set
			if (!this.tempFiltersData[key]) {
				this.tempFiltersData[key] = new Set();
			}

			// 添加到 Set 中（自动去重）
			this.tempFiltersData[key].add(value);
		},

		finalizeFilters() {
			// 将临时过滤器数据转换为最终的 filtersData
			for (const key in this.tempFiltersData) {
				this.filtersData[key] = Array.from(this.tempFiltersData[key]).map((value) => ({
					text: value,
					value,
				}));
			}

			// 对 filtersData 排序
			this.sortFilter();
		},

		sortFilter() {
			for (const key in this.filtersData) {
				this.filtersData[key] = this.$tools.customSort(this.filtersData[key], "text");
			}
		},
		// 获取保养件详情
		async getMaintenance() {
			const { datas } = await getMaintenance(this.$route.query);
			// this.maintenance = datas[this.$route.query.index];
			this.maintenance = datas;
			this.tableData = [];

			if (this.maintenance.length) {
				this.getOeCar();
			}
		},

		// 获取 OE 车型信息
		async getOeCar() {
			let oes = this.maintenance.map((item) => {
				return item.oes;
			});

			oes = [...new Set(oes.flat())];

			for (let index = 0; index < oes.length; index++) {
				const oe = oes[index];
				const brand_code = this.maintenance[0].brand_code;
				const { datas } = await getOeCar({ oe, brand_code });

				datas.items = Array.from(new Map(datas.items.map((item) => [item.hw_id, item])).values());

				let _data = datas.items.map((item) => {
					item.oe_code = oe;
					this.addUniqueFilter("brand", item.brand);
					this.addUniqueFilter("models", item.models);
					this.addUniqueFilter("chassiscode", item.chassiscode);
					this.addUniqueFilter("sop", item.sop);
					this.addUniqueFilter("eop", item.eop);
					this.addUniqueFilter("enginemodel", item.enginemodel);
					this.addUniqueFilter("transmissiontype", item.transmissiontype);
					return item;
				});

				this.tableData = this.$tools.sortCharAt([...this.tableData, ..._data], "brand");

				// this.tableData = this.$tools.sortCharAt([...this.tableData, ..._data], "oe_code", "models", "sop");

				// 最后一个车型时，处理过滤器
				if (index === oes.length - 1) {
					this.finalizeFilters();
				}
			}

			this._tableData = this.tableData;
		},
	},
};
</script>

<style lang="less" scoped>
.virtual-list {
	max-height: 300px;
	overflow-y: auto;
	// width: 220px;
}
.vertical-checkbox-group {
	display: flex;
	flex-direction: column;
}

.page {
	background: #f8f9fb;
	width: 100%;
	padding-bottom: 30px;
	min-height: calc(100vh - 30px - 220px);
}
.content {
	width: 1350px;
	margin: 0 auto;
	border: 1px solid #e6e6e6;
	background: #fff;
	margin-top: 15px;
	padding: 25px;
}
.mess {
	align-items: flex-start;
}
.indicator-active {
	border: 1px solid @theme-color !important;
}
.swiper {
	width: 300px;
	.el-carousel {
		border: 1px solid #e6e6e6;
	}
	.indicator {
		display: flex;
		align-items: center;
		margin-top: 10px;
		.indicator-item {
			width: 50px;
			height: 50px;
			border: 1px solid #e6e6e6;
			margin-right: 5px;
			cursor: pointer;
			&:last-child {
				margin-right: 0;
			}
			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}
}
.info {
	flex: 1;
	align-items: flex-start;
	margin-left: 20px;

	.title {
		font-size: 26px;
		font-weight: 550;
		margin-bottom: 20px;
	}
}
.spec {
	width: 100%;
	border: 1px solid #e6e6e6;
	margin-top: 10px;
	.name {
		background-color: #f9f9f9;
		color: @theme-color;
		font-size: 15px;
		padding: 5px 10px;
		font-weight: 550;
		border-bottom: 1px solid #e6e6e6;
	}
	.spec-list {
		padding: 0 10px 10px 10px;
		.spec-item {
			margin-top: 10px;
			font-size: 14px;
			color: #666;
		}
	}
}
.table {
	width: 100%;
	// margin-top: 20px;
	border-bottom: 1px solid #e6e6e6;
	border-right: 1px solid #e6e6e6;
	border-left: 1px solid #e6e6e6;
	&:nth-child(2) {
		border-top: 1px solid #e6e6e6;
	}
	.table-item {
		width: 49.5%;

		.table-item-name {
			background-color: #f5f9fc;
			width: 50%;
			text-align: center;
			padding: 8px 0;
			border-right: 1px solid #e6e6e6;
		}
		.table-item-value {
			width: 50%;
			text-align: center;
		}
	}
}
</style>
